'use client';
import { useEffect } from 'react';

const UpdateState = ({state_slug}: {state_slug: string}) => {
  useEffect(() => {
    const event: CustomEvent<string> = new CustomEvent('selected_state', {
      detail: state_slug, // Replace 'state_slug' with the actual state slug you
    });
    window.dispatchEvent(event);(event);
  }, []);

  return null;
};

export default UpdateState;